/* eslint-disable react/jsx-no-undef */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import {
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Drawer,
  TextField,
  Select,
  MenuItem,
  Slider,
  Autocomplete,
} from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
interface MemberFilterProps {
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  setStartDate: (date: Dayjs | null) => void;
  setEndDate: (date: Dayjs | null) => void;
  handleSubmit?: (clearData?: any) => void;
  membershipType: string;
  setMembershipType: (value: string) => void;
  membership: string;
  setMembership: (value: string) => void;
  subscriptionType: string;
  setSubscriptionType: (value: string) => void;
  gender: string;
  setGender: (value: string) => void;
  subscriptionStartDate: Dayjs | null;
  setSubscriptionStartDate: (date: Dayjs | null) => void;
  expiryDate: Dayjs | null;
  setExpiryDate: (date: Dayjs | null) => void;
  interests: any[];
  expertise: any[];
  dietary: any[];
  selectedExpertise: string[];
  setSelectedExpertise: (value: string[]) => void;
  selectedDietary: string[];
  setSelectedDietary: (value: string[]) => void;
  selectedInterests: string[];
  setSelectedInterests: (value: string[]) => void;
  onlyLoggedIn: boolean;
  setOnlyLoggedIn: (value: boolean) => void;
  notCreatedOrder: boolean;
  setNotCreatedOrder: (value: boolean) => void;
  activeMembersDays: boolean;
  setActiveMembersDays: (value: boolean) => void;
  inactiveMembers: boolean;
  setInactiveMembers: (value: boolean) => void;
  newSignupMembers: boolean;
  setNewSignupMembers: (value: boolean) => void;
  expiringInDays: boolean;
  setExpiringInDays: (value: boolean) => void;
  minAge: number;
  setMinAge: (value: number) => void;
  maxAge: number;
  setMaxAge: (value: number) => void;
  handleClearFilters: () => void;
}

function MemberFilter({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  handleSubmit,
  membershipType,
  setMembershipType,
  membership,
  setMembership,
  subscriptionType,
  setSubscriptionType,
  gender,
  setGender,
  subscriptionStartDate,
  setSubscriptionStartDate,
  expiryDate,
  setExpiryDate,
  interests,
  expertise,
  dietary,
  selectedExpertise,
  setSelectedExpertise,
  selectedDietary,
  setSelectedDietary,
  selectedInterests,
  setSelectedInterests,
  onlyLoggedIn,
  setOnlyLoggedIn,
  notCreatedOrder,
  setNotCreatedOrder,
  activeMembersDays,
  setActiveMembersDays,
  inactiveMembers,
  setInactiveMembers,
  newSignupMembers,
  setNewSignupMembers,
  expiringInDays,
  setExpiringInDays,
  minAge,
  setMinAge,
  maxAge,
  setMaxAge,
  handleClearFilters,
}: MemberFilterProps) {
  const [openDrawer, setOpenDrawer] = useState(false);

  const toggleDrawer = (open: boolean) => () => {
    setOpenDrawer(open);
  };

  const handleChange = (event: Event, newValue: number | number[]) => {
    if (Array.isArray(newValue)) {
      setMinAge(newValue[0]);
      setMaxAge(newValue[1]);
    }
  };
  const handleExpertiseChange = (event: any, value: any[]) => {
    const selectedNames = value?.map((item) => item?.name);
    setSelectedExpertise(selectedNames);
  };

  const handleDietaryChange = (event: any, value: any[]) => {
    const selectedNames = value?.map((item) => item);
    setSelectedDietary(selectedNames);
  };

  const handleInterestsChange = (event: any, value: any[]) => {
    const selectedNames = value?.map((item) => item?.name);
    setSelectedInterests(selectedNames);
  };

  const [autoCompleteOpen, setAutoCompleteOpen] = useState(true);

  const handleClearAll = () => {
    setStartDate(null);
    setEndDate(null);
    setMembershipType("");
    setSubscriptionType("");
    setMembership("");
    setGender("");
    setSubscriptionStartDate(null);
    setSelectedDietary([]);
    setSelectedExpertise([]);
    setSelectedInterests([]);
    setOpenDrawer(false);
    handleSubmit?.(true);
    setMinAge(0);
    setMaxAge(100);
    setActiveMembersDays(false);
    setNewSignupMembers(false);
    setInactiveMembers(false);
    handleClearFilters();
  };

  return (
    <>
      <Button onClick={toggleDrawer(true)} className="btn btn_primary">
        <img src="/static/images/filter_icon.svg" alt="icon" /> Filters
      </Button>

      <Drawer
        anchor="right"
        open={openDrawer}
        onClose={() => {
          setOpenDrawer(false);
          handleClearAll();
        }}
        className="filter_drawer"
      >
        <div style={{ width: 420, padding: 20 }} className="filter_body">
          <div
            className="filter_head"
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: 20,
            }}
          >
            <h3>Filters</h3>
            <a onClick={handleClearAll} style={{ cursor: "pointer" }}>
              Clear All
            </a>
          </div>

          <div className="gap_m">
            <>
              <FormGroup className="text_checkbox">
                <label className="w_100">Membership Type</label>

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={membershipType === "Single"}
                      onChange={() =>
                        setMembershipType(
                          membershipType === "Single" ? "" : "Single"
                        )
                      }
                    />
                  }
                  label="Single"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={membershipType === "Duo"}
                      onChange={() =>
                        setMembershipType(membershipType === "Duo" ? "" : "Duo")
                      }
                    />
                  }
                  label="Duo"
                />
              </FormGroup>

              <FormGroup className="text_checkbox">
                <label className="w_100">Status</label>

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={membership === "Trial"}
                      onChange={() =>
                        setMembership(membership === "Trial" ? "" : "Trial")
                      }
                    />
                  }
                  label="Trial"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={membership === "Paid"}
                      onChange={() =>
                        setMembership(membership === "Paid" ? "" : "Paid")
                      }
                    />
                  }
                  label="Paid"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={membership === "Complementary"}
                      onChange={() =>
                        setMembership(
                          membership === "Complementary" ? "" : "Complementary"
                        )
                      }
                    />
                  }
                  label="Complementary"
                />
              </FormGroup>

              <div className="control_group w_50">
                <label>Select Subscription</label>
                <Select
                  className="dropse"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  inputProps={{
                    "aria-label": "Without label",
                  }}
                  displayEmpty
                  name="type"
                  value={subscriptionType}
                  onChange={(e) => setSubscriptionType(e.target.value)}
                >
                  <MenuItem value="" disabled>
                    Select Subscription
                  </MenuItem>

                  <MenuItem value="Monthly">Monthly</MenuItem>
                  <MenuItem value="Quarterly">Quarterly</MenuItem>
                  <MenuItem value="Annually">Annually</MenuItem>
                  <MenuItem value="SemiAnnually">Semi Annually</MenuItem>
                </Select>
              </div>

              <div className="control_group w_50">
                <label>Select Gender</label>
                <Select
                  className="dropse"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  inputProps={{
                    "aria-label": "Without label",
                  }}
                  displayEmpty
                  name="type"
                  value={gender}
                  onChange={(e) => setGender(e.target.value)}
                >
                  <MenuItem value="" disabled>
                    Select Gender
                  </MenuItem>

                  <MenuItem value="Male"> Male</MenuItem>
                  <MenuItem value="Female">Female</MenuItem>
                  <MenuItem value="Both">Both</MenuItem>
                </Select>
              </div>
              <div className="control_group w_100">
                <label>Select Age Range</label>
                <Slider
                  getAriaLabel={() => "Age range"}
                  value={[minAge, maxAge]}
                  onChange={handleChange}
                  valueLabelDisplay="auto"
                  getAriaValueText={(value) => `${value}`}
                  min={0}
                  max={100}
                />
              </div>

              <div className="w_100 control_group date_field">
                <label>Subscription Start Date</label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    className="form_control"
                    format="DD/MM/YYYY"
                    value={subscriptionStartDate}
                    slotProps={{
                      textField: {
                        placeholder: "Start Date",
                        sx: {
                          "& .MuiInputBase-input.Mui-disabled": {
                            WebkitTextFillColor: "#9999",
                            opacity: 1,
                          },
                        },
                      },
                    }}
                    onChange={(newValue) =>
                      setSubscriptionStartDate?.(newValue)
                    }
                    slots={{
                      openPickerIcon: () => (
                        <img
                          src="/static/images/calendar_icon.svg"
                          alt="icon"
                        />
                      ),
                      // textField: (params) => (
                      //   <TextField
                      //     {...params}
                      //     fullWidth
                      //     placeholder="Start Date"
                      //     hiddenLabel
                      //   />
                      // ),
                    }}
                    desktopModeMediaQuery="(min-width:0px)"
                  />
                </LocalizationProvider>
              </div>

              <div className="w_100 control_group date_field">
                <label>Expiry Date</label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    className="form_control"
                    format="DD/MM/YYYY"
                    value={expiryDate}
                    slotProps={{
                      textField: {
                        placeholder: "Expiry Date",
                        sx: {
                          "& .MuiInputBase-input.Mui-disabled": {
                            WebkitTextFillColor: "#9999",
                            opacity: 1,
                          },
                        },
                      },
                    }}
                    onChange={(newValue) => setExpiryDate?.(newValue)}
                    slots={{
                      openPickerIcon: () => (
                        <img
                          src="/static/images/calendar_icon.svg"
                          alt="icon"
                        />
                      ),
                      // textField: (params) => (
                      //   <TextField
                      //     {...params}
                      //     fullWidth
                      //     placeholder="Start Date"
                      //     hiddenLabel
                      //   />
                      // ),
                    }}
                    desktopModeMediaQuery="(min-width:0px)"
                  />
                </LocalizationProvider>
              </div>

              <div className="w_50 control_group date_field">
                <label>Start Date</label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    className="form_control"
                    format="DD/MM/YYYY"
                    value={startDate}
                    slotProps={{
                      textField: {
                        placeholder: "Start Date",
                        sx: {
                          "& .MuiInputBase-input.Mui-disabled": {
                            WebkitTextFillColor: "#9999", // change text & placeholder color
                            opacity: 1,
                          },
                        },
                      },
                    }}
                    onChange={(newValue) => setStartDate?.(newValue)}
                    slots={{
                      openPickerIcon: () => (
                        <img
                          src="/static/images/calendar_icon.svg"
                          alt="icon"
                        />
                      ),
                      // textField: (params) => (
                      //   <TextField
                      //     {...params}
                      //     fullWidth
                      //     placeholder="Start Date"
                      //     hiddenLabel
                      //   />
                      // ),
                    }}
                    desktopModeMediaQuery="(min-width:0px)"
                  />
                </LocalizationProvider>
              </div>
              <div className="w_50 control_group date_field">
                <label>End Date</label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    className="form_control"
                    value={endDate}
                    onChange={(newValue) => setEndDate?.(newValue)}
                    minDate={dayjs(startDate)}
                    format="DD/MM/YYYY"
                    slotProps={{
                      textField: {
                        placeholder: "End Date",
                        sx: {
                          "& .MuiInputBase-input.Mui-disabled": {
                            WebkitTextFillColor: "#9999", // change text & placeholder color
                            opacity: 1,
                          },
                        },
                      },
                    }}
                    slots={{
                      openPickerIcon: () => (
                        <img
                          src="/static/images/calendar_icon.svg"
                          alt="icon"
                        />
                      ),
                    }}
                    desktopModeMediaQuery="(min-width:0px)"
                    disabled={!startDate}
                  />
                </LocalizationProvider>
              </div>
              <div className="control_group w_100">
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  options={expertise}
                  value={expertise?.filter((option) =>
                    selectedExpertise?.includes(option?.name)
                  )}
                  onChange={handleExpertiseChange}
                  getOptionLabel={(option) => option?.name}
                  isOptionEqualToValue={(option: any, value: any) =>
                    option?.name === value?.name
                  }
                  onOpen={() => setAutoCompleteOpen(true)}
                  onClose={() => setAutoCompleteOpen(false)}
                  renderOption={(props, option: any, { selected }) => {
                    return (
                      <li {...props}>
                        <FormControlLabel
                          control={<Checkbox checked={selected} />}
                          name="option"
                          label={option?.name}
                        />
                      </li>
                    );
                  }}
                  renderInput={(params) => (
                    <TextField {...params} placeholder="Select Expertise" />
                  )}
                />
              </div>

              <div className="control_group w_100">
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  options={dietary}
                  value={dietary?.filter((option) =>
                    selectedDietary?.includes(option)
                  )}
                  onChange={handleDietaryChange}
                  getOptionLabel={(option) => option}
                  isOptionEqualToValue={(option: any, value: any) =>
                    option === value
                  }
                  onOpen={() => setAutoCompleteOpen(true)}
                  onClose={() => setAutoCompleteOpen(false)}
                  renderOption={(props, option: any, { selected }) => {
                    return (
                      <li {...props}>
                        <FormControlLabel
                          control={<Checkbox checked={selected} />}
                          name="option"
                          label={option}
                        />
                      </li>
                    );
                  }}
                  renderInput={(params) => (
                    <TextField {...params} placeholder="Select Dietary" />
                  )}
                />
              </div>

              <div className="control_group w_100">
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  options={interests}
                  value={interests?.filter((option) =>
                    selectedInterests?.includes(option?.name)
                  )}
                  onChange={handleInterestsChange}
                  getOptionLabel={(option) => option?.name}
                  isOptionEqualToValue={(option: any, value: any) =>
                    option?.name === value?.name
                  }
                  onOpen={() => setAutoCompleteOpen(true)}
                  onClose={() => setAutoCompleteOpen(false)}
                  renderOption={(props, option: any, { selected }) => {
                    return (
                      <li {...props}>
                        <FormControlLabel
                          control={<Checkbox checked={selected} />}
                          name="option"
                          label={option?.name}
                        />
                      </li>
                    );
                  }}
                  renderInput={(params) => (
                    <TextField {...params} placeholder="Select Interest" />
                  )}
                />
              </div>

              <div className="control_group ">
                <FormGroup
                  className="paid_checkbox"
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 3,
                  }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={onlyLoggedIn}
                        onChange={() => setOnlyLoggedIn(!onlyLoggedIn)}
                      />
                    }
                    label="Logged in Users"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={notCreatedOrder}
                        onChange={() => setNotCreatedOrder(!notCreatedOrder)}
                      />
                    }
                    label="Didn't Created Order"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={activeMembersDays}
                        onChange={() =>
                          setActiveMembersDays(!activeMembersDays)
                        }
                      />
                    }
                    label="Active Members (Last 30 Days)"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={inactiveMembers}
                        onChange={() => setInactiveMembers(!inactiveMembers)}
                      />
                    }
                    label="Inactive Members"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={expiringInDays}
                        onChange={() => setExpiringInDays(!expiringInDays)}
                      />
                    }
                    label="Expiring Memberships"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={newSignupMembers}
                        onChange={() => setNewSignupMembers(!newSignupMembers)}
                      />
                    }
                    label="New Member Signups"
                  />
                </FormGroup>
              </div>
            </>
          </div>

          <div className="btn_flex">
            <Button
              className="btn btn_primary"
              onClick={() => {
                if (handleSubmit) {
                  handleSubmit();
                }
                setOpenDrawer(false);
              }}
            >
              Save
            </Button>
          </div>
        </div>
      </Drawer>
    </>
  );
}

export default MemberFilter;
